import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import AddEquipment from '../../AddEquipment/AddEquipment'
import Button from 'components/Button/Button'
import { StyledContinueButtonContainer } from './ValueAddEquipmentForm.styled'

const ValueAddEquipmentForm = (props: any) => {
  const { t } = useTranslation()
  const [showValidation, setShowValidation] = useState(false)
  const [validationErrors, setValidationErrors] = useState([])
  const { setCurrentTab, isModernizationDisabled } = props

  const onBackClick = () => {
    setCurrentTab((tab) => tab - 1)
  }

  const onContinueClick = () => {
    setShowValidation(true)
    if (validationErrors.length === 0) {
      setCurrentTab((tab) => tab + (isModernizationDisabled ? 2 : 1))
    }
  }

  return (
    <>
      <AddEquipment
        showValidation={showValidation}
        setShowValidation={setShowValidation}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
      />
      <StyledContinueButtonContainer>
        <Button kind="primary" onClick={() => onBackClick()}>
          {t('common.backButton')}
        </Button>
        <Button kind="primary" onClick={() => onContinueClick()}>
          {t('common.continueButton')}
        </Button>
      </StyledContinueButtonContainer>
    </>
  )
}

export default ValueAddEquipmentForm
